
import Button from '../../../components/base/Button';

export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              当院について
            </h2>
            <p className="text-gray-600 mb-6">
              当院は、患者様一人ひとりに寄り添った丁寧な診療を心がけております。最新の医療技術と豊富な経験を活かし、皆様の健康をサポートいたします。
            </p>
            <div className="space-y-4">
              <div className="flex items-center">
                <i className="ri-check-line text-blue-600 mr-3"></i>
                <span className="text-gray-700">経験豊富な柔道整復師による施術</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line text-blue-600 mr-3"></i>
                <span className="text-gray-700">最新の医療機器を完備</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line text-blue-600 mr-3"></i>
                <span className="text-gray-700">患者様に寄り添った丁寧な対応</span>
              </div>
            </div>
          </div>
          <div className="flex justify-center">
            <img 
              src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/460aa91c55a2fb6d3a707f95b18c9479.jpeg"
              alt="さすがのスタッフ"
              className="w-full max-w-2xl h-[400px] rounded-lg shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
